import { c as _c } from "react/compiler-runtime";
import * as React from "react";
const MailIcon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg xmlns="http://www.w3.org/2000/svg" width="41" height="32" viewBox="0 0 41 32" fill="none"><path d="M36.9 8L20.5 18L4.1 8V4L20.5 14L36.9 4M36.9 0H4.1C1.8245 0 0 1.78 0 4V28C0 29.0609 0.431963 30.0783 1.20086 30.8284C1.96976 31.5786 3.01261 32 4.1 32H36.9C37.9874 32 39.0302 31.5786 39.7991 30.8284C40.568 30.0783 41 29.0609 41 28V4C41 1.78 39.155 0 36.9 0Z" fill="white" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default MailIcon;